// ARCHIVO COMPARTIDO app/web — editar en ambos repos. Verificar con `npm run check:shared` (TemControlApp).
//
// Fiestas laborales OFICIALES de ámbito nacional y de Comunidad Autónoma, tal
// cual las publica el BOE (fuente oficial; decisión de producto "seguir la
// fuente oficial").
//
//   2026 → BOE-A-2025-21667: Resolución de 17 de octubre de 2025, de la
//          Dirección General de Trabajo, por la que se publica la relación de
//          fiestas laborales para el año 2026 (BOE núm. 259, 28-oct-2025).
//          https://www.boe.es/diario_boe/txt.php?id=BOE-A-2025-21667
//
// POR QUÉ UNA TABLA Y NO UNA REGLA:
//   - RD 2001/1983 art. 45.2: SOLO las fiestas nacionales del art. 45.1 que
//     caen en domingo se trasladan al lunes, y cada CCAA puede sustituir ese
//     lunes por una fiesta propia (art. 45.3). Así que "domingo → lunes" NO es
//     universal: en 2026 (1-nov y 6-dic en domingo) el BOE no trae fila para el
//     domingo, solo el lunes (2-nov / 7-dic) marcado en las CCAA que lo
//     disfrutan (p.ej. AN, EX, MD los dos; RI solo el 7-dic; CT y VC ninguno).
//   - Las APIs públicas se equivocan justo ahí (OpenHolidays no trae los lunes
//     de AN, EX, AS, CL y mete extras falsos como EX 2026-02-13 o MD
//     2026-07-25; Nager no trae ningún lunes sustitutorio ni el 19-mar de VC).
//   - Art. 46: los festivos LOCALES (hasta 2 por municipio) se publican en su
//     fecha real y no se trasladan. No están aquí: los da de alta el admin en
//     el backend (FestivosPage de la web).
//
// Canarias trae 11 fechas: la 12ª es insular (nota 1 del BOE: Decreto
// 61/2025 — p.ej. Gran Canaria 8-sep, Tenerife 2-feb) y se gestiona como
// festivo local. En Cataluña, Arán cambia el 26-dic por el 17-jun (nota 2),
// también como local.
//
// ACTUALIZACIÓN ANUAL (obligatoria): el BOE publica cada octubre la tabla del
// año siguiente ("relación de fiestas laborales para el año AAAA"). Añadir el
// año nuevo a OFFICIAL_HOLIDAYS y a OFFICIAL_HOLIDAY_SOURCES, en AMBOS repos
// (TemControlApp y TemControlFront), con una entrada por fecha marcada en cada
// columna (*, ** y ***). El test de frescura de officialHolidays.test.js (web)
// se pone en ROJO a partir del 15 de noviembre si falta la tabla del año
// siguiente. Mientras un año no tenga tabla se usa OpenHolidays → Nager (ver
// spainHolidays.js), SIN ningún traslado de domingos.
//
// Claves: códigos ISO 3166-2 que devuelven subdivisionForCommunity /
// subdivisionForProvince (spainHolidays.js): las 17 CCAA + ES-CE / ES-ML.

export const OFFICIAL_HOLIDAY_SOURCES = {
  2026: 'BOE-A-2025-21667',
};

// año → subdivisión → [{ date: 'YYYY-MM-DD', name }]
export const OFFICIAL_HOLIDAYS = {
  2026: {
    'ES-AN': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-02-28', name: 'Día de Andalucía' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-11-02', name: 'Día siguiente a Todos los Santos' },
      { date: '2026-12-07', name: 'Lunes siguiente al Día de la Constitución Española' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-AR': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-04-23', name: 'San Jorge/Día de Aragón' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-11-02', name: 'Día siguiente a Todos los Santos' },
      { date: '2026-12-07', name: 'Lunes siguiente al Día de la Constitución Española' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-AS': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-09-08', name: 'Día de Asturias' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-11-02', name: 'Día siguiente a Todos los Santos' },
      { date: '2026-12-07', name: 'Lunes siguiente al Día de la Constitución Española' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-IB': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-03-02', name: 'Lunes siguiente al Día de les Illes Balears' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-04-06', name: 'Lunes de Pascua' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
      { date: '2026-12-26', name: 'San Esteban' },
    ],
    'ES-CN': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-05-30', name: 'Día de Canarias' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-11-02', name: 'Día siguiente a Todos los Santos' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-CB': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-07-28', name: 'Día de las Instituciones de Cantabria' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-09-15', name: 'La Bien Aparecida' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-12-07', name: 'Lunes siguiente al Día de la Constitución Española' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-CM': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-04-06', name: 'Lunes de Pascua' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-06-04', name: 'Corpus Christi' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-11-02', name: 'Día siguiente a Todos los Santos' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-CL': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-04-23', name: 'Fiesta de Castilla y León' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-11-02', name: 'Día siguiente a Todos los Santos' },
      { date: '2026-12-07', name: 'Lunes siguiente al Día de la Constitución Española' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-CT': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-04-06', name: 'Lunes de Pascua' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-06-24', name: 'San Juan' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-09-11', name: 'Fiesta Nacional de Cataluña' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
      { date: '2026-12-26', name: 'San Esteban' },
    ],
    'ES-EX': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-09-08', name: 'Día de Extremadura' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-11-02', name: 'Día siguiente a Todos los Santos' },
      { date: '2026-12-07', name: 'Lunes siguiente al Día de la Constitución Española' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-GA': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-03-19', name: 'San José' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-06-24', name: 'San Juan' },
      { date: '2026-07-25', name: 'Santiago Apóstol/Día Nacional de Galicia' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-MD': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-05-02', name: 'Fiesta de la Comunidad de Madrid' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-11-02', name: 'Día siguiente a Todos los Santos' },
      { date: '2026-12-07', name: 'Lunes siguiente al Día de la Constitución Española' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-MC': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-03-19', name: 'San José' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-06-09', name: 'Día de la Región de Murcia' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-12-07', name: 'Lunes siguiente al Día de la Constitución Española' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-NC': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-03-19', name: 'San José' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-04-06', name: 'Lunes de Pascua' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-11-02', name: 'Día siguiente a Todos los Santos' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-PV': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-03-19', name: 'San José' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-04-06', name: 'Lunes de Pascua' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-07-25', name: 'Santiago Apóstol/Día Nacional de Galicia' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-RI': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-04-06', name: 'Lunes de Pascua' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-06-09', name: 'Día de La Rioja' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-12-07', name: 'Lunes siguiente al Día de la Constitución Española' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-VC': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-03-19', name: 'San José' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-04-06', name: 'Lunes de Pascua' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-06-24', name: 'San Juan' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-10-09', name: 'Día de la Comunitat Valenciana' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-CE': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-05-27', name: 'Fiesta Sacrificio-Eidul Adha' },
      { date: '2026-08-05', name: 'Nuestra Señora de África' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-09-02', name: 'Día de Ceuta' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
    'ES-ML': [
      { date: '2026-01-01', name: 'Año Nuevo' },
      { date: '2026-01-06', name: 'Epifanía del Señor' },
      { date: '2026-03-20', name: 'Fiesta del Eid Fitr' },
      { date: '2026-04-02', name: 'Jueves Santo' },
      { date: '2026-04-03', name: 'Viernes Santo' },
      { date: '2026-05-01', name: 'Fiesta del Trabajo' },
      { date: '2026-05-27', name: 'Fiesta Sacrificio-Aid al Adha' },
      { date: '2026-08-15', name: 'Asunción de la Virgen' },
      { date: '2026-10-12', name: 'Fiesta Nacional de España' },
      { date: '2026-12-07', name: 'Lunes siguiente al Día de la Constitución Española' },
      { date: '2026-12-08', name: 'Inmaculada Concepción' },
      { date: '2026-12-25', name: 'Natividad del Señor' },
    ],
  },
};

const yearKey = (year) => {
  const n = Number(year);
  return Number.isInteger(n) && n > 0 ? n : null;
};

// ¿Tenemos la tabla oficial del BOE para ese año?
export const hasOfficialYear = (year) => {
  const y = yearKey(year);
  return y != null && Object.prototype.hasOwnProperty.call(OFFICIAL_HOLIDAYS, y);
};

// Fechas NACIONALES de un año = las marcadas en TODAS las subdivisiones de la
// tabla (se calcula, así nunca se desincroniza de los datos). Memoizado.
const nationalCache = new Map(); // year → Set<ISO>
const nationalDatesOf = (y) => {
  if (nationalCache.has(y)) return nationalCache.get(y);
  const lists = Object.values(OFFICIAL_HOLIDAYS[y]);
  const set = new Set(lists.length ? lists[0].map((h) => h.date) : []);
  for (const list of lists.slice(1)) {
    const own = new Set(list.map((h) => h.date));
    for (const d of Array.from(set)) if (!own.has(d)) set.delete(d);
  }
  nationalCache.set(y, set);
  return set;
};

// Festivos oficiales (nacionales + autonómicos) de una subdivisión en un año:
//   [{ date, name, scope: 'national' | 'regional' }] ordenados por fecha.
//   scope 'national' = marcado para todas las CCAA; si no, 'regional'.
// Sin subdivisión (o una que no está en la tabla) → SOLO los nacionales.
// Año sin tabla → [] (el llamador decide el fallback: hasOfficialYear).
// Devuelve copias: mutarlas no altera la tabla.
export const officialHolidaysFor = (year, subdivisionCode = null) => {
  if (!hasOfficialYear(year)) return [];
  const y = yearKey(year);
  const table = OFFICIAL_HOLIDAYS[y];
  const national = nationalDatesOf(y);
  const own = subdivisionCode && Object.prototype.hasOwnProperty.call(table, subdivisionCode)
    ? table[subdivisionCode]
    : null;
  const source = own || (Object.values(table)[0] || []).filter((h) => national.has(h.date));
  return source
    .map((h) => ({ date: h.date, name: h.name, scope: national.has(h.date) ? 'national' : 'regional' }))
    .sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
};
